/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Switchtoplan2Inputs */

const en_switchtoplan2 = /** @type {(inputs: Switchtoplan2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switch to ${i?.tier}`)
};

const de_switchtoplan2 = /** @type {(inputs: Switchtoplan2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu ${i?.tier} wechseln`)
};

/**
* | output |
* | --- |
* | "Switch to {tier}" |
*
* @param {Switchtoplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const switchtoplan2 = /** @type {((inputs: Switchtoplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switchtoplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_switchtoplan2(inputs)
	return de_switchtoplan2(inputs)
});
export { switchtoplan2 as "switchToPlan" }